import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ManageBranchService } from './api/services';
const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};

    if (!oldPassword.trim()) newErrors.oldPassword = "Old password is required.";
    if (!newPassword.trim()) newErrors.newPassword = "New password is required.";
    if (!confirmPassword.trim()) newErrors.confirmPassword = "Confirm password is required.";
    if (newPassword && confirmPassword && newPassword !== confirmPassword)
      newErrors.confirmPassword = "New Password and Confirm Password do not match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()){
        const  payLoad ={
          "oldPassword":oldPassword,
          "newPassword": newPassword
         }
         ManageBranchService.ChangePassword(payLoad)
            .then((res) => {
              if (res.data.code == "201") {
                alert(res.data.error_message);
              } else {
                alert(res.data.results);
              }
              navigate(-1)
            })
            .catch((err) => {
              console.error('Failed to Recharge:', err);
            });
    }else{
        return;
    } 

    // Submit logic here
    console.log("Password changed");
    // navigate("/dashboard"); // example route after success
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-5 col-12">
          <div className="form-outer p-4 shadow rounded">
            <h4 className="text-center mb-4 text-danger">Change Password</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>Old Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                />
                {errors.oldPassword && (
                  <small className="text-danger">{errors.oldPassword}</small>
                )}
              </div>

              <div className="form-group mb-3">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                {errors.newPassword && (
                  <small className="text-danger">{errors.newPassword}</small>
                )}
              </div>

              <div className="form-group mb-4">
                <label>Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {errors.confirmPassword && (
                  <small className="text-danger">{errors.confirmPassword}</small>
                )}
              </div>

              <button type="submit" className="btncommonColor w-100">
                CHANGE
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
